import { Provider } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";

import {
  ADMIN_PRONOSTICSV2_PATH,
  ADMIN_BINGO_PATH,
  ADMIN_CLICK_AND_COLLECTS_PATH,
  ADMIN_CROSSBARS_PATH,
  ADMIN_EVENTS_PATH,
  ADMIN_HTML_PAGE_PATH,
  ADMIN_PLACES_PATH,
  ADMIN_PATH,
  ADMIN_PRONOSTICS_PATH,
  ADMIN_QUIZZES_PATH,
  ADMIN_WALLS_PATH,
  ADMIN_WORKFORCES_PATH,
  BINGO_GAME_PATH,
  BINGO_SCREEN_PATH,
  EVENT_PATH,
  GAME_PATH,
  LOGIN_PATH,
  QUIZ_PATH,
  SCREEN_PATH,
  WALL_PATH,
  PRONOSTICSV2_PATH,
  ADMIN_CHAMPIONSHIPS_PATH,
  ADMIN_SONOMETER_PATH,
  SONOMETER_SCREEN_PATH,
} from "_urls";
import { store } from "core/store";

import { AdminLayout } from "common/layouts/AdminLayout";
import { AdminMenuView } from "common/admin/AdminMenuView";
// import { AdminStagingHome } from "pages/home/AdminStagingHome";

import { DebugProvider } from "common/debug/contexts/DebugContext";

import Login from "common/admin/auth/Login";
import RequireAuth from "common/admin/auth/RequireAuth";

import { ClickAndCollectAdminRoutes } from "click-and-collect/routes/ClickAndConnectAdminRoutes";

import { EventAdminRoutes } from "event/routes/EventAdminRoutes";
import { EventPlayRoutes } from "event/routes/EventPlayRoutes";

import { CrossbarAdminRoutes } from "crossbar/routes/CrossbarAdminRoutes";

import { PronosticsAdminRoutes } from "pronostic/routes/PronosticsAdminRoutes";

import { QuizAdminRoutes } from "quiz/routes/QuizAdminRoutes";
import { QuizScreencastRoutes } from "quiz/routes/QuizScreencastRoutes";
import { QuizGamePlayRoutes } from "quiz/routes/QuizGamePlayRoutes";

import { WallAdminRoutes } from "wall/routes/WallAdminRoutes";
import { WallScreenRoutes } from "wall/routes/WallScreenRoutes";
import { WallPlayRoutes } from "wall/routes/WallPlayRoutes";

import { Pronosticsv2AdminRoutes } from "pronosticsv2/routes/Pronosticsv2AdminRoutes";

import { WorkforceAdminRoutes } from "workforce/admin/WorkforceAdminRoutes";

import "./App.css";
import { BingoAdminRoutes } from "bingo/routes/BingoAdminRoutes";
import { BingoScreencastRoutes } from "bingo/routes/BingoScreenCastRoutes";

import { HtmlPageAdminRoutes } from "htmlpage/routes/HtmlPagesAdminRoutes";
import { PlaceAdminRoutes } from "place/routes/PlaceAdminRoutes";
import { PronosticsV2Routes } from "pronosticsv2/routes/PronosticsV2Routes";
import { ChampionshipAdminRoutes } from "championship/routes/ChampionshipAdminRoutes";
import AdminProductionHomePage from "pages/home/AdminProductionHomePage";
import { SonometerScreencastRoutes } from "sonometer/routes/SonometerScreenRoutes";
import { SonometerAdminRoutes } from "sonometer/routes/SonometerAdminRoutes";
import { TestRedirectorView } from "event/play/views/TestRedirectorView";

function App() {
  return (
    <DebugProvider>
      <Provider store={store}>
        <MantineProvider
          theme={{ primaryColor: "violet", colorScheme: "light" }}
          withGlobalStyles
          withNormalizeCSS
        >
          <ModalsProvider modalProps={{ style: { overflow: "hidden" } }}>
            <Routes>
              {/* {process.env.REACT_APP_ENV === "staging" ? (
                <Route path="" element={<AdminStagingHome />} />
              ) : (
                <Route path="" element={<AdminProductionHomePage />} />
              )} */}
              <Route path="" element={<AdminProductionHomePage />} />

              <Route path={ADMIN_PATH}>
                <Route path={LOGIN_PATH} element={<Login />} />
                <Route element={<RequireAuth />}>
                  <Route element={<AdminLayout />}>
                    <Route path="" element={<AdminMenuView />} />
                    <Route
                      path={`${ADMIN_HTML_PAGE_PATH}/*`}
                      element={<HtmlPageAdminRoutes />}
                    />
                    <Route
                      path={`${ADMIN_PRONOSTICSV2_PATH}/*`}
                      element={<Pronosticsv2AdminRoutes />}
                    />
                    <Route
                      path={`${ADMIN_BINGO_PATH}/*`}
                      element={<BingoAdminRoutes />}
                    />
                    <Route
                      path={`${ADMIN_CLICK_AND_COLLECTS_PATH}/*`}
                      element={<ClickAndCollectAdminRoutes />}
                    />

                    <Route
                      path={`${ADMIN_EVENTS_PATH}/*`}
                      element={<EventAdminRoutes />}
                    />
                    <Route
                      path={`${ADMIN_CROSSBARS_PATH}/*`}
                      element={<CrossbarAdminRoutes />}
                    />

                    <Route
                      path={`${ADMIN_PRONOSTICS_PATH}/*`}
                      element={<PronosticsAdminRoutes />}
                    />
                    <Route
                      path={`${ADMIN_QUIZZES_PATH}/*`}
                      element={<QuizAdminRoutes />}
                    />
                    <Route
                      path={`${ADMIN_WALLS_PATH}/*`}
                      element={<WallAdminRoutes />}
                    />
                    <Route
                      path={`${ADMIN_WORKFORCES_PATH}/*`}
                      element={<WorkforceAdminRoutes />}
                    />
                    <Route
                      path={`${ADMIN_PLACES_PATH}/*`}
                      element={<PlaceAdminRoutes />}
                    />
                    <Route
                      path={`${ADMIN_CHAMPIONSHIPS_PATH}/*`}
                      element={<ChampionshipAdminRoutes />}
                    />
                    <Route
                      path={`${ADMIN_SONOMETER_PATH}/*`}
                      element={<SonometerAdminRoutes />}
                    />
                    <Route
                      path="test-redirector"
                      element={<TestRedirectorView />}
                    />
                  </Route>
                </Route>
              </Route>

              <Route path={`${EVENT_PATH}/*`} element={<EventPlayRoutes />} />

              <Route path={`${QUIZ_PATH}/*`} element={<QuizGamePlayRoutes />} />

              {/* Temporary Pronostics Path */}

              <Route
                path={`${PRONOSTICSV2_PATH}/*`}
                element={<PronosticsV2Routes />}
              />

              <Route path={`${WALL_PATH}/*`} element={<WallPlayRoutes />} />

              <Route path={`${SCREEN_PATH}/*`}>
                <Route
                  path={`${GAME_PATH}/*`}
                  element={<QuizScreencastRoutes />}
                />
                <Route path={`${WALL_PATH}/*`} element={<WallScreenRoutes />} />
              </Route>

              <Route path={`${BINGO_SCREEN_PATH}/*`}>
                <Route
                  path={`${BINGO_GAME_PATH}/*`}
                  element={<BingoScreencastRoutes />}
                />
              </Route>

              <Route
                path={`${SONOMETER_SCREEN_PATH}/*`}
                element={<SonometerScreencastRoutes />}
              />
            </Routes>
          </ModalsProvider>
        </MantineProvider>
      </Provider>
    </DebugProvider>
  );
}

export default App;
